module.exports = "<div class=Form__body><nav class=Tiles><div v-for=\"tile in tiles\" class=Tile><header class=Tile__header><h3 class=Tile__title>{{ tile.legend }}</h3></header><div class=Tile__body><component is=type_button :fdata=tile.button[0]></component></div></div></nav></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/nav/tiled.vue
// module id = 466
// module chunks = 0